import { Suspense, lazy } from 'react';
import { useThemeStore } from '@/stores/theme-store';
import type { MonacoInfoEditorProps } from './MonacoInfoEditor';

/**
 * Lazy boundary around the Monaco INFO editor. Monaco is ~2 MB; operators who never open a
 * customer's INFO must not pay for it, and jsdom unit tests must never reach the real import
 * (Monaco cannot mount there).
 */
const MonacoInfoEditor = lazy(() => import('./MonacoInfoEditor'));

export function CustomerInfoJsonEditor(props: Omit<MonacoInfoEditorProps, 'isDark'>) {
  const mode = useThemeStore((s) => s.mode);
  return (
    <Suspense
      fallback={
        <div
          className="flex flex-1 min-h-0 items-center justify-center rounded border bg-muted"
          data-testid={props.testId ? `${props.testId}-loading` : undefined}
        >
          <span className="text-xs text-muted-foreground">{'Loading editor…'}</span>
        </div>
      }
    >
      <MonacoInfoEditor {...props} isDark={mode === 'dark'} />
    </Suspense>
  );
}
